export const GET_LOCAL_PUBLIC_MEMBER_STATIONS = gql`
  query GetLocalPublicMemberStations {
    stations(isLocalPublicMember: true) {
      borderStation
      callSign
      colorBackground
      colorPrimary
      colorSecondary
      id
      isLocalPublicDemoMember
      isLocalPublicMember
      name
      smallColorLogo: image(profile: "station-color-logo") {
        transformTemplate
      }
    }
  }
`
